export const REVIEW_THANK_YOU_CONTEXT = "review";

export const TESTIMONIAL_REVIEW_TABS = [
  { id: "Holiday", label: "Holidays" },
  { id: "Hotel", label: "Stays" },
  { id: "Flight", label: "Flights" },
  { id: "Activity", label: "Activities" },
];

export function getTestimonialReviewTabs(isIndia = false) {
  if (isIndia) {
    return TESTIMONIAL_REVIEW_TABS.filter((tab) => tab.id === "Holiday");
  }
  return TESTIMONIAL_REVIEW_TABS;
}

export function getReviewModuleOptions(isIndia = false) {
  return getTestimonialReviewTabs(isIndia).map(({ id, label }) => ({
    value: id,
    label,
  }));
}

export function normalizePath(path = "") {
  if (path.startsWith("/in/")) return path.replace("/in", "");
  if (path === "/in") return "/";
  return path;
}

export function getModuleTypeFromPath(path = "") {
  if (path.startsWith("/holiday")) return "Holiday";
  if (path.startsWith("/activity")) return "Activity";
  if (path.startsWith("/staycations")) return "Staycation";
  if (path.startsWith("/visa")) return "Visa";
  if (path.startsWith("/hotel")) return "Hotel";
  if (path.startsWith("/page")) return "CountryCityPage";
  if (path.startsWith("/deals")) return "SeasonalDealsPage";
  return null;
}

export function getSlugFromPath(path = "") {
  const cleaned = normalizePath(path);
  const parts = cleaned.split("/").filter(Boolean);
  if (parts.length === 1) return null;
  return parts[1];
}

export function formatStatCount(value = 0) {
  const count = Number(value) || 0;
  if (count >= 1_000_000) {
    const compact = count / 1_000_000;
    return `${Number.isInteger(compact) ? compact : compact.toFixed(1)}M+`;
  }
  if (count >= 1000) {
    const compact = count / 1000;
    return `${Number.isInteger(compact) ? compact : compact.toFixed(1)}K+`;
  }
  return String(count);
}

export function formatReviewCount(value = 0) {
  return (Number(value) || 0).toLocaleString("en-US");
}
